// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"a4699d66","221":"e6ccc4c0","223":"d4e2d099","285":"c56ae590","355":"c495b90f","412":"38406736","453":"1aa225c0","455":"4d901100","768":"92c4d766","977":"a95a937f"}[chunkId] + ".chunk.js";
};